module.exports = __webpack_public_path__ + "ts.png?10a160dd966f111286318fe9bb89f012";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ts.png
// module id = 778
// module chunks = 0